import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { Login } from '@models/login.model';

declare var gapi: any;

@Injectable({
    providedIn: 'root'
})

export class AuthenticationService {

    urlBackend = environment.urlBackend;

    CLIENT_ID = '112796379741-g0j4k2alarijfeu40le2gfd31d8opbde.apps.googleusercontent.com';
    API_KEY = 'AIzaSyA-qFOyRzAzneKTaS771kWhePKEPXZGU-A';
    SCOPES = 'profile email';

    googleAuth: any;

    constructor(private http: HttpClient) { }


    initClient() {
        return new Promise((resolve, reject) => {
            gapi.load('client:auth2', () => {
                return gapi.client.init({
                    apiKey: this.API_KEY,
                    clientId: this.CLIENT_ID,
                    scope: this.SCOPES,
                }).then((res) => {
                    this.googleAuth = gapi.auth2.getAuthInstance();
                    resolve();
                }).catch(err => console.log('Error Google init:', err));
            });
        });

    }

    get isSignedIn(): boolean {
        return this.googleAuth.isSignedIn.get();
    }

    signIn() {
        return this.googleAuth.signIn({
            prompt: 'consent'
        }).then((googleUser: any) => {
            const emailUser = googleUser.getBasicProfile().getEmail();
            const nombreUser = googleUser.getBasicProfile().getName();
            const urlImagen = googleUser.getBasicProfile().getImageUrl();
            localStorage.clear();
            localStorage.setItem('e15x2m', btoa(emailUser));
            localStorage.setItem('n15x2b', btoa(nombreUser));
            localStorage.setItem('u15x2i', btoa(urlImagen));
        });
    }

    signOut(): void {
        this.googleAuth.signOut();
    }

    validateUser(emailUser: string): Observable<Login> {
        return this.http.post<Login>(`${this.urlBackend}/log_work/user`, { correo: emailUser });
    }

    isUserSaved(): boolean {
        return localStorage.getItem('n15x2b') !== null;
    }
}
